import React from 'react';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { ToastContainer, toast } from 'react-toastify';
import { getOne, create } from './../../../common/v4/BackendProvider';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
var imm = require('immutable');

const CarrierCreate = () => {
    const [data, setData] = useState({
        ATRBALANCE: 0.00,
        ATRCREDLIM: 0.00, 
        ATRLOWBALANCELEVEL: 0.00
    });
    const [metadata, setMetadata] = useState([]);
    const carrier_id = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        getOne(`/admin/carriers/carriers/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
            }).catch(error => {
                toast.error("Error fetching carrier: " + error.message, {});
            });
    }, [carrier_id]);

    const handleSave = () => {
        create(`/admin/carriers/carriers/`, {data: data}).then(response => {
            toast.success("Carrier created successfully", {});
            navigate('/carriers/carriers');
        }).catch(error => {
            toast.error("Error creating carrier: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/carriers/carriers');
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    const onChangeId = (id, value) => {
        setData({...data, [id]: value});
    };

    const onChangeName = (id, value) => {
        console.log(value);
        setData({...data, 
            'ATRNAME': value,
            'unique_id': value.substring(0,4).toUpperCase().replace(/[^A-Z0-9-_]/g, '')
        });
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Interconnect" >
                <EditPagePanel>
                    <EditPageTextField label="Unique ID" id="unique_id" onChange={ onChangeId } value={ data.unique_id } />
                    <EditPageTextField label="Name" id="ATRNAME" onChange={ onChangeName } value={ data.ATRNAME } />
                    <EditPageTextField label="Email" id="ATREMAIL" onChange={ onChange } value={ data.ATREMAIL } />
                    <EditPageSelect label="Reseller" id="ATRRESELLERID" onChange={ onChange } value={ data.ATRRESELLERID } options={ metadata?.resellers?.values } />
                    <EditPageSelect label="Currency" id="ATRCURID" onChange={ onChange } value={ data.ATRCURID } options={ metadata?.currencies?.values } />
                    <EditPageSelect label="Time Zone" id="ATRTIMEZONE" onChange={ onChange } value={ data.ATRTIMEZONE }  options={ metadata?.timezones?.values } />
                    <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange }  value={ data.ATRSTATUS } />
                    <EditPageCheckbox label="Web Login" id="ATRALLOWWEB" onChange={ onChange } value={ data.ATRALLOWWEB } />
                    <EditPageTextField label="Web Username" id="ATRWEBLOGIN" onChange={ onChange } value={ data.ATRWEBLOGIN } />
                    <EditPageTextField label="Web Password" id="ATRWEBPASS" autocomplete="new-password" type="password" onChange={ onChange } value={ data.ATRWEBPASS } />
                </EditPagePanel>
                <EditPagePanel>
                    <EditPageTextField label="Credit Limit" id="ATRCREDLIM"  addonLeft={ data.currency?.ATRCURNAME } onChange={ onChange } value={ data.ATRCREDLIM } />
                    <EditPageSelect label="Payment Terms" nullable={ true } id="payment_term_id" onChange={ onChange } value={ data.payment_term_id } options={ metadata?.payment_terms?.values } />
                    <EditPageCheckbox label="Low balance alert" id="ATRNOTIFY" onChange={ onChange } value={ data.ATRNOTIFY } />
                    <EditPageTextField label="Notify Level" id="ATRLOWBALANCELEVEL" addonLeft={ data.currency?.ATRCURNAME } onChange={ onChange } value={ data.ATRLOWBALANCELEVEL } />
                    <EditPageSelect label="Invoice Template" id="invoice_template_id" onChange={ onChange } value={ data.invoice_template_id } options={ metadata?.invoice_templates?.values } />    
                    <EditPageTextField label="Billing Email" id="billing_email" onChange={ onChange } value={ data.billing_email } />
                    <EditPageTextField label="NOC Email" id="noc_email" onChange={ onChange } value={ data.noc_email } />
                    <EditPageTextField label="Rates Email" id="rates_email" onChange={ onChange } value={ data.rates_email } />
                </EditPagePanel>
                <EditPagePanel>
                    <EditPageTextField label="Address 1" id="ATRADDR1" onChange={ onChange } value={ data.ATRADDR1 } />
                    <EditPageTextField label="Address 2" id="ATRADDR2" onChange={ onChange } value={ data.ATRADDR2 } />
                    <EditPageTextField label="City" id="ATRCITY" onChange={ onChange } value={ data.ATRCITY } />
                    <EditPageTextField label="State" id="ATRSTATE" onChange={ onChange } value={ data.ATRSTATE } />
                    <EditPageTextField label="ZIP" id="ATRZIP" onChange={ onChange } value={ data.ATRZIP } />
                    <EditPageSelect label="Country" id="ATRCOUNTRYID" onChange={ onChange } value={ data.ATRCOUNTRYID } options = { metadata?.countries?.values } nullable={ true } />
                    <EditPageTextField label="VAT Number" id="ATRCUST3" onChange={ onChange } value={ data.ATRCUST3 } />
                    <EditPageTextField label="Phone" id="ATRPHONE1" onChange={ onChange } value={ data.ATRPHONE1 } />
                    <EditPageTextField label="Phone 2" id="ATRPHONE2" onChange={ onChange } value={ data.ATRPHONE2 } />             
                    <EditPageTextField label="Billing Address 1" id="ATRBILLADDR1" onChange={ onChange } value={ data.ATRBILLADDR1 } />
                    <EditPageTextField label="Billing Address 2" id="ATRBILLADDR2" onChange={ onChange } value={ data.ATRBILLADDR2 } />
                    <EditPageTextField label="Billing City" id="ATRBILLCITY" onChange={ onChange } value={ data.ATRBILLCITY } />
                    <EditPageTextField label="Billing State" id="ATRBILLSTATE" onChange={ onChange } value={ data.ATRBILLSTATE } />
                    <EditPageTextField label="Billing ZIP" id="ATRBILLZIP" onChange={ onChange } value={ data.ATRBILLZIP } />
                    <EditPageSelect label="Billing Country" id="ATRBILLCOUNTRYID" onChange={ onChange } value={ data.ATRBILLCOUNTRYID }  options = { metadata?.countries?.values } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default CarrierCreate;